import React from 'react';
import { mobileMQ, smallMobileMQ } from '../../modules/theme';
import { pixelToRem } from '../ui';
import { useIsMobile } from '../../hooks/mobile';
import { formatNum } from '../../modules/format-number';

const Li = props => {
  return (
    <li
      css={{
        listStyle: 'none',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: 'rgba(22,34,83,0.8)',
        borderRadius: '4px',
        height: 36,
        color: 'white',
        fontWeight: 'bold',
        padding: '10px',
        minWidth: 250,
        fontSize: pixelToRem(14),
        [mobileMQ]: {
          width: '32%',
          flexDirection: 'column-reverse',
          height: 'initial',
          fontSize: pixelToRem(16),
          minWidth: 'initial',
        },
        [smallMobileMQ]: {},
      }}
    >
      {props.children}
    </li>
  );
};

const Img = props => {
  return (
    // eslint-disable-next-line
    <img
      css={{ marginRight: '5px', display: 'inline-block !important' }}
      {...props}
    />
  );
};
const Number = ({ children }) => {
  return <span css={{ fontSize: '22px' }}>{children}</span>;
};
const Aggregations = ({ aggregations }) => {
  const isMobile = useIsMobile();

  return (
    <div
      css={{
        width: 270,
        [mobileMQ]: { width: '100%' },
        [smallMobileMQ]: { marginBottom: 10 },
      }}
    >
      <ul
        css={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100%',
          [mobileMQ]: {
            flexDirection: 'row',
            marginBottom: 10,
          },
        }}
      >
        <Li>
          <span>
            <Img src={`${process.env.URL}/oval.svg`} alt="oval" />
            {isMobile ? 'Records' : 'Records of frogs'}
          </span>
          <Number>{formatNum(aggregations.recordOfFrogs)}</Number>
        </Li>
        <Li>
          <span>
            <Img src={`${process.env.URL}/frog.svg`} alt="frog" />

            {isMobile ? 'Species' : 'Unique species'}
          </span>
          <Number>{formatNum(aggregations.uniqueSpecies)}</Number>
        </Li>
        <Li>
          <span>
            <Img src={`${process.env.URL}/user.svg`} alt="user" />

            {isMobile ? 'Users' : 'Unique users'}
          </span>
          <Number>{formatNum(aggregations.uniqueUsers)}</Number>
        </Li>
      </ul>
    </div>
  );
};

export default Aggregations;
